/**
 * Test IDs for QA automation.
 */
export const testIds = {
  accountSetupModalOrganizationName: "account-setup-modal-organization-name",
  accountSetupModalDotNumber: "account-setup-modal-dot-number",
  accountSetupModalNext: "account-setup-modal-next",
  accountSetupModalStartFleetTrial: "account-setup-modal-start-fleet-trial",
  accountSetupModalStartLiquidTrial: "account-setup-modal-start-liquid-trial",
  accountSetupModalActivate: "account-setup-modal-activate",
  accountSetupModalLogout: "account-setup-modal-logout",
} as const;
